import React, { useState, useEffect, useRef } from 'react';
import { Select, Tag, Button, Divider, Flex } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import tagStore from '../../store/TagStore';
import TagManagementModal from './TagManagementModal';

const TagSelector = observer(({ value = [], onChange }) => {
    const [managementOpen, setManagementOpen] = useState(false);
    const selectRef = useRef(null);

    useEffect(() => {
        tagStore.fetchTags();
    }, []);

    useEffect(() => {
        if (!onChange) return;
        const validIds = new Set(tagStore.tags.map(tag => tag.id));
        const nextValue = value.filter((id) => validIds.has(id));
        if (nextValue.length !== value.length) {
            onChange(nextValue);
        }
    }, [tagStore.tags, value, onChange]);

    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;
        const tag = tagStore.getTagById(value);
        
        return (
            <Tag
                color={tag?.color}
                closable={closable}
                onClose={onClose}
                style={{ marginRight: 3 }}
            >
                {label}
            </Tag>
        );
    };

    return (
        <>
            <div style={{ position: 'relative' }}>
                {value.length > 0 && (
                    <Button type="link" size="small" style={{ position: 'absolute', right: 0, top: -28, padding: 0, height: 'auto', zIndex: 1 }} onClick={() => onChange?.([])}>
                        Очистить
                    </Button>
                )}
                <Select
                ref={selectRef}
                mode="multiple"
                value={value}
                onChange={onChange}
                style={{ width: '100%' }}
                placeholder="Выберите теги"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                optionRender={(option) => (
                    <Tag color={option.data?.color} style={{ marginRight: 0 }}>
                        {option.label}
                    </Tag>
                )}
                tagRender={tagRender}
                options={tagStore.tags.map(tag => ({
                    value: tag.id,
                    label: tag.name,
                    color: tag.color,
                }))}
                loading={tagStore.loading}
                maxTagCount="responsive"
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <Button
                            type="link"
                            icon={<SettingOutlined />}
                            onClick={() => {
                                selectRef.current?.blur();
                                setTimeout(() => setManagementOpen(true), 100);
                            }}
                            size="small"
                            style={{ padding: '4px 12px 8px 12px', width: '100%', textAlign: 'left' }}
                        >
                            Настроить теги
                        </Button>
                    </>
                )}
            />
            </div>

            <TagManagementModal
                open={managementOpen}
                onClose={() => setManagementOpen(false)}
            />
        </>
    );
});

export default TagSelector;

